// Заглушка для пользователя без аватара
const DEFAULT_USER_AVATAR = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHJ4PSIyMCIgZmlsbD0iI0U1RTdFQiIvPgogIDxwYXRoIGQ9Ik0yMCAxOEMyMS42NTY5IDE4IDIzIDE2LjY1NjkgMjMgMTVDMjMgMTMuMzQzMSAyMS42NTY5IDEyIDIwIDEyQzE4LjM0MzEgMTIgMTcgMTMuMzQzMSAxNyAxNUMxNyAxNi42NTY5IDE4LjM0MzEgMTggMjAgMThaIiBmaWxsPSIjOUM5RkE2Ii8+CiAgPHBhdGggZD0iTTI3IDI4QzI3IDI0LjY4NjMgMjMuODY2IDIyIDIwIDIyQzE2LjEzNCAyMiAxMyAyNC42ODYzIDEzIDI4SDI3WiIgZmlsbD0iIzlDOUZBNiIvPgo8L3N2Zz4=';

// Получение URL аватара пользователя
export const getUserAvatarUrl = (avatar) => {
  if (!avatar) {
    return DEFAULT_USER_AVATAR;
  }
  // Аватар уже содержит правильный путь /uploads/avatars/...
  return avatar;
};

// Получение URL аватара команды с заглушкой на основе первой буквы названия
export const getTeamAvatarUrl = (avatar, teamName) => {
  if (!avatar) {
    const letter = teamName ? teamName.charAt(0).toUpperCase() : 'T';
    const svg = `<svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'><rect width='40' height='40' rx='8' fill='#E5E7EB'/><text x='50%' y='50%' font-family='Arial' font-size='18' font-weight='bold' fill='#9C9FA6' text-anchor='middle' dominant-baseline='middle'>${letter}</text></svg>`;
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
  }
  return avatar;
};

// Обработчик ошибки загрузки аватара пользователя
export const handleUserAvatarError = (e) => {
  e.target.src = DEFAULT_USER_AVATAR;
};

// Обработчик ошибки загрузки аватара команды
export const handleTeamAvatarError = (e, teamName) => {
  e.target.src = getTeamAvatarUrl(null, teamName);
};